// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'crosshairs';

export const Component = () => (
  <path d='M12.5 7.955A4.544 4.544 0 0 0 7.955 12.5a4.544 4.544 0 0 0 4.545 4.545 4.544 4.544 0 0 0 4.545-4.545A4.544 4.544 0 0 0 12.5 7.955zm10.159 3.409a10.221 10.221 0 0 0-9.023-9.023V0h-2.272v2.341a10.221 10.221 0 0 0-9.023 9.023H0v2.272h2.341a10.221 10.221 0 0 0 9.023 9.023V25h2.272v-2.341a10.221 10.221 0 0 0 9.023-9.023H25v-2.272h-2.341zM12.5 20.455A7.95 7.95 0 0 1 4.545 12.5 7.95 7.95 0 0 1 12.5 4.545a7.95 7.95 0 0 1 7.955 7.955 7.95 7.95 0 0 1-7.955 7.955z' />
);

export const viewBox = '0 0 25 25';
